import wiseMedicalCenterLogoIcon from "../image/wiseMedicalCenterLogoIcon.png";
import facebookIcon from "../image/facebook-icon.png";
import instagramIcon from "../image/instagram-icon.png";
import youtubeIcon from "../image/youtube-icon.png";

export const WiseMedicalCenterFooter = () => {
  return (
    <div className="company-footer" style={{ backgroundColor: "white" }}>
        <div className="d-flex align-items-center gap-3 p-3">
            <img src={wiseMedicalCenterLogoIcon} alt="Wise Medical Center" style={{ width: "auto", height: "73px" }}/>
            <div style={{lineHeight:"30px"}}>
                <div className="d-flex align-items-center flex-wrap" style={{lineHeight:"20px"}}>
                    <label style={{ fontSize: "16px", color: "#02789E", fontWeight: "500",marginRight: "2px" }}>Contact Us :</label>
                    <a href="tel:+97466655790" style={{ textDecoration: "none",fontSize: "14px", color: "#827c7c", fontWeight: "500", }}>97466655790</a>,
                    <a href="tel:+97450777611" style={{ textDecoration: "none",fontSize: "14px", color: "#827c7c", fontWeight: "500", }}>97450777611</a>,
                    <a href="tel:+97444832288" style={{ textDecoration: "none",fontSize: "14px", color: "#827c7c", fontWeight: "500", }}>97444832288</a>
                </div>

                <div className="d-flex align-items-center flex-wrap gap-2">
                    <label style={{fontSize: "16px",color: "#02789E",fontWeight: "500",whiteSpace: "nowrap"}}>Social Media :</label>
                    <div className="d-flex flex-nowrap gap-2">                        
                        <a href="https://www.facebook.com/wise.medi" target="_blank" style={{textDecoration:"none"}}><img style={{ width: "auto", height: "20px" }} src={facebookIcon} alt="Facebook" /></a>
                        <a href="https://www.instagram.com/wise_medical_center?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" style={{textDecoration:"none"}}><img style={{ width: "auto", height: "20px" }} src={instagramIcon} alt="Instagram" /></a>
                        <a href="https://www.youtube.com/@WiseMedicalCenter-qatar" target="_blank" style={{textDecoration:"none"}}><img style={{ width: "auto", height: "20px" }} src={youtubeIcon} alt="YouTube" /></a>
                    </div>
                </div>
            </div>
        </div>        
        <span className="d-flex justify-content-end">
            <p style={{fontSize:"12px",margin:"0 30px 5px 0"}}>Designed & Developed By <a href="https://basilhut.com/" target="_blank" style={{color:"#02789E",fontSize:"14px",textDecoration:"none",fontWeight:"600"}}>BasilHut</a><span>_</span><a href="https://basilhut.com/" target="_blank" style={{color:"#02789E",fontSize:"14px",textDecoration:"none",fontWeight:"600"}}>Magunex</a></p>
        </span>
      <div style={{borderTop:"1.5px solid #D5D5D5",}}>
            <p style={{fontSize:"12px",margin:0,padding:"5px 0",display:"flex",alignItems:"center",justifyContent:"center"}}>© Copyright 2021, Wise Medical Center. All Rights Reserved.</p>
      </div>
    </div>
  );
};

